
<mat-card class="thru-notation-dialog">
  <!-- Header -->
  <mat-card-header class="header-container">
    <div justify="space-between" class="row center full-width">
      <div class="row center full-width">
        <lib-key [hierarchyItem]="selectiveData.masterKey"> </lib-key>
        <span *ngIf="selectiveData.action === 'CHANGE_KEYS'" class="header-text">Change Keys</span>
        <span *ngIf="selectiveData.action === 'MASTER_KEYS'" class="header-text">Sub Masters</span>
        <span *ngIf="selectiveData.action === 'DELETE_KEYS'" class="header-text">Delete Change Keys</span>
      </div>
      <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </mat-card-header>
  <mat-divider></mat-divider>
  <!-- Content -->
    <mat-card-content class="padding lrg all">
      <form [formGroup]="thruForm" (keyup.enter)="submit()">
        <!-- Prefix -->
        <div class="row full-width">
          <mat-form-field floatLabel="always" appearance="outline" class="full-width">
              <mat-label
                for="prefix"
                [ngClass]="{
                  'error-message': fieldHasError(thruForm, 'prefix'),
                  focus: focus.prefix
                }"
              >
                Prefix
              </mat-label>

            <div class="row">
              <input
                id="prefix"
                class="uppercase"
                [ngClass]="{
                error: fieldHasError(thruForm, 'prefix'),
                disabled: false,
                'focus-border': focus.prefix
                }"
                placeholder="Prefix"
                formControlName="prefix"
                (focus)="focusOn('prefix')"
                (focusout)="focusOn('prefix')"
                aria-describedby="prefix errors"
                cdkFocusInitial
                matInput
              />

              <mat-icon *ngIf="fieldHasError(thruForm, 'prefix')" class="error-icon">warning
              </mat-icon>
            </div>

            <!-- Errors -->
            <div *ngFor="let validation of errorMessages.prefix" id="prefixErrors">
              <div class="caption error-message margin lrg top" *ngIf="fieldHasErrorMessages(thruForm, validation, 'prefix')">
                {{ validation.message }}
              </div>
            </div>
          </mat-form-field>
        </div>

        <!-- from -->
        <div class="row full-width">
          <mat-form-field floatLabel="always" appearance="outline" class="full-width">
              <mat-label
                for="from"
                [ngClass]="{
                  'error-message': fieldHasError(thruForm, 'from'),
                  focus: focus.from
                }"
              >
                From <span *ngIf="lasSKD?.keySetSymbol">( Last used: {{ lasSKD?.keySetSymbol }} )</span>
              </mat-label>

            <div class="row">
              <input
                id="from"
                class="uppercase"
                [ngClass]="{
                error: fieldHasError(thruForm, 'from'),
                disabled: false,
                'focus-border': focus.from
                }"
                maxlength="{{ max }}"
                placeholder="From"
                formControlName="from"
                (focus)="focusOn('from')"
                (focusout)="focusOn('from')"
                aria-describedby="from errors"
                matInput
              />

              <mat-icon *ngIf="fieldHasError(thruForm, 'from')" class="error-icon">
                warning
              </mat-icon>
            </div>

            <!-- Errors -->
            <div *ngFor="let validation of errorMessages.from" id="fromErrors">
              <div class="caption error-message margin lrg top" *ngIf="fieldHasErrorMessages(thruForm, validation, 'from')">
                {{ validation.message }}
              </div>
            </div>
          </mat-form-field>
        </div>

        <!-- to -->
        <div class="row full-width">
          <mat-form-field floatLabel="always" appearance="outline" class="full-width">
              <mat-label
                for="to"
                [ngClass]="{
                  'error-message': fieldHasError(thruForm, 'to'),
                  focus: focus.to
                }"
              >
                To
              </mat-label>

            <div class="row">
              <input
                id="to"
                class="uppercase"
                [ngClass]="{
                error: fieldHasError(thruForm, 'to'),
                disabled: false,
                'focus-border': focus.to
                }"
                maxlength="{{ max }}"
                placeholder="To"
                formControlName="to"
                (focus)="focusOn('to')"
                (focusout)="focusOn('to')"
                aria-describedby="to errors"
                min="0"
                cdkFocusInitial
                matInput
              />

              <mat-icon *ngIf="fieldHasError(thruForm, 'to')" class="error-icon">warning
              </mat-icon>
            </div>

            <!-- Errors -->
            <div *ngFor="let validation of errorMessages.to" id="toErrors">
              <div class="caption error-message margin lrg top" *ngIf="fieldHasErrorMessages(thruForm, validation, 'to')">
                {{ validation.message }}
              </div>
            </div>
          </mat-form-field>
        </div>

        <!-- Suffix -->
        <div class="row full-width">
          <mat-form-field floatLabel="always" appearance="outline" class="full-width">
              <mat-label
                for="suffix"
                [ngClass]="{
                  'error-message': fieldHasError(thruForm, 'suffix'),
                  focus: focus.suffix
                }"
              >
                Suffix
              </mat-label>

            <div class="row">
              <input
                id="suffix"
                class="uppercase"
                [ngClass]="{
                error: fieldHasError(thruForm, 'suffix'),
                disabled: false,
                'focus-border': focus.suffix
              }"
                placeholder="Suffix"
                formControlName="suffix"
                (focus)="focusOn('suffix')"
                (focusout)="focusOn('suffix')"
                aria-describedby="suffix errors"
                cdkFocusInitial
                matInput
              />

              <mat-icon *ngIf="fieldHasError(thruForm, 'suffix')" class="error-icon">
                warning
              </mat-icon>
            </div>

            <!-- Errors -->
            <div *ngFor="let validation of errorMessages.suffix" id="suffixErrors">
              <div class="caption error-message margin lrg top" *ngIf="fieldHasErrorMessages(thruForm, validation, 'suffix')">
                {{ validation.message }}
              </div>
            </div>
          </mat-form-field>
        </div>

        <!-- Allow Exclusions -->
        <div *ngIf="selectiveData.action === 'MASTER_KEYS' || selectiveData.action === 'CHANGE_KEYS'" class="row full-width">
          <mat-checkbox
            id="allowExclusions"
            color="primary"
            formControlName="allowExclusions"
            [checked]="thruForm.controls.allowExclusions.value"
            aria-label="Allow Exclusions"
            aria-describedby="allowExclusionsHint"
          >
            Allow Exclusions
          </mat-checkbox>
        </div>
      </form>
    </mat-card-content>

  <!-- Buttons -->
  <mat-card-actions>
    <div class="row flex-end">
      <button mat-stroked-button id="cancel" (click)="close()"> Cancel </button>
      <button
        mat-flat-button
        class="margin left"
        *ngIf="selectiveData.action === 'CHANGE_KEYS' || selectiveData.action === 'MASTER_KEYS'"
        [ngClass]="{'create-button': thruForm.valid}"
        id="save"
        (click)="submit()"
        [disabled]="!thruForm.valid"
      >
        Create
      </button>
      <button
       mat-flat-button
        class="margin left"
        *ngIf="selectiveData.action === 'DELETE_KEYS'"
        [ngClass]="{'delete-button': thruForm.valid}"
        id="save"
        (click)="submit()"
        [disabled]="!thruForm.valid"
      >
        Delete
      </button>
    </div>
  </mat-card-actions>
</mat-card>

